import { ProjectManagementStatus } from '@round/api';
import { GenericDropdownOption } from 'App.types';
import { ValueType } from 'react-select';

type StatusMeta = {
    label: string;
    color: string;
};

export const projectStatusMeta: Record<ProjectManagementStatus, StatusMeta> = {
    PITCHING: { label: 'Pitching', color: '#06b6d4' },
    BRIEF_CREATING_LIST: { label: 'Brief / Creating List', color: '#eab308' },
    GOING_LIVE_GETTING_DRAFTS: { label: 'Going Live / Getting Drafts', color: '#3b82f6' },
    REPORT_NEEDED: { label: 'Report Needed', color: '#f97316' },
    STAND_BY: { label: 'Stand By', color: '#94a3b8' },
    APPROVED_PENDING_LAUNCH: { label: 'Approved / Pending Launch', color: '#10b981' },
    WRAPPED_UP: { label: 'Wrapped Up', color: '#64748b' },
    ON_ICE: { label: 'On Ice', color: '#0ea5e9' },
    DECLINED: { label: 'Declined', color: '#ef4444' },
};

export const projectStatusOptions: GenericDropdownOption<ProjectManagementStatus>[] = [
    { value: 'PITCHING', label: projectStatusMeta.PITCHING.label },
    { value: 'BRIEF_CREATING_LIST', label: projectStatusMeta.BRIEF_CREATING_LIST.label },
    { value: 'GOING_LIVE_GETTING_DRAFTS', label: projectStatusMeta.GOING_LIVE_GETTING_DRAFTS.label },
    { value: 'REPORT_NEEDED', label: projectStatusMeta.REPORT_NEEDED.label },
    { value: 'STAND_BY', label: projectStatusMeta.STAND_BY.label },
    { value: 'APPROVED_PENDING_LAUNCH', label: projectStatusMeta.APPROVED_PENDING_LAUNCH.label },
    { value: 'WRAPPED_UP', label: projectStatusMeta.WRAPPED_UP.label },
    { value: 'ON_ICE', label: projectStatusMeta.ON_ICE.label },
    { value: 'DECLINED', label: projectStatusMeta.DECLINED.label },
];

export type ProjectStatusOption = GenericDropdownOption<ProjectManagementStatus>;

export const getValue = (value: ValueType<{}, boolean>): ValueType<ProjectStatusOption, false> => {
    return (Array.isArray(value) && value.length === 1 ? value[0] : value) as ValueType<ProjectStatusOption, false>;
};
